import React, { useContext, useEffect, useState } from 'react'
import ContextMenu from '../ContextMenu/ContextMenu'
import { MenuItem, MenuList, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import NewComment from './ContextActions/NewComment';
import NewGetData from './ContextActions/NewGetData';
import NewTranslateData from './ContextActions/NewTranslateData';
import NewVariable from './ContextActions/NewVariable';
import NewConditionalIfField from './ContextActions/NewConditionalFieldIF';
import CopyAndPaste, { getSelectedNodes } from './ContextActions/CopyAndPaste';
import { ParentScreenCtx } from '../../pages/workbench_build/WorkbenchBuild';
import { useSelector } from 'react-redux';
import NewAction from './ContextActions/NewAction';
import NewLoop from './ContextActions/NewLoop';
import NewConditionalELSEField from './ContextActions/NewConditionalFieldELSE';
import NewPlugin from './ContextActions/NewPlugin';
import Delete from './ContextActions/Delete';
import NewCallWorkflow from './ContextActions/NewCallWorkflow';
import NewTradingPartnerLookup from './ContextActions/NewTradingPartnerLookup';
import NewErrorHandler from './ContextActions/NewErrorHandler';
import NewSendData from './ContextActions/NewSendData';
import NewTrackingReport from './ContextActions/NewTrackingReport';
import { eachDeep } from 'deepdash-es/standalone';

function WorkflowTemplateOptionsMenu({ targetId, isCopied, setIsCopied, setMenuOptionViaProp = '', resetMenuOption = () => {}}) {
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const { t } = useTranslation();
  const [menuOption, setMenuOption] = useState('')
  const [isDisable, setIsDisable] = useState(false);
  const [showElse, setShowElse] = useState(false);
  const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
  const selectedKeysArray = tree[currentTab].selectedKeysArray;
  const checkDisable = () => {
    return selectedKeysArray.includes("wf-0")
  }

  useEffect(() => {
    setIsDisable(checkDisable());
  }, [selectedKeysArray])
  
  useEffect(()=> {
    if(selectedNode.ICON_DISPLAY==="CONDITION_IF"){
     let found = false;
     eachDeep(tree[currentTab]?.translatedData,(obj)=>{
       if(obj?.nodeId===selectedNode.nodeId && obj?.ICON_DISPLAY==="CONDITION_ELSE"){
         setShowElse(false)
         found = true;
        return;
       }
     })
     if (!found){
       setShowElse(true);
     }
    }
    else {
      const splitedKey = selectedNode?.key?.split("-") || [];
      splitedKey.pop();
      let parentKey = splitedKey.join("-");
      const parentNodes = getSelectedNodes([parentKey], tree[currentTab]?.translatedData, true);
      const hasConditionIfParent = parentNodes.some(node => node.ICON_DISPLAY === "CONDITION_IF");
      if (hasConditionIfParent && parentNodes.length === 1) {
        setShowElse(true);
      }else if (hasConditionIfParent && parentNodes.length > 1) {
        setShowElse(false);
      }else {
        setShowElse(false);
      }
    }
   },[selectedNode?.key])

  const handleClick = (opt) => {
    setMenuOption(opt)
    resetMenuOption(opt)
  }

  useEffect(() => {
    setMenuOption(setMenuOptionViaProp)
  }, [setMenuOptionViaProp]);

  return (
    <>
      <ContextMenu targetId={targetId}>
        <Paper elevation={3} sx={{ width: "19rem" }}>
          <MenuList sx={{ paddingTop: 0, paddingBottom: 0 }}>
            <MenuItem name={t('MNU_NEW_GET_DATA')} onClick={() => handleClick(t('MNU_NEW_GET_DATA'))}>
              <span className='INBOUND_TEMPLATE'></span>
              <span className='margin-left-8'>{t('MNU_NEW_GET_DATA')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_TRANSLATE')} onClick={() => handleClick(t('MNU_NEW_TRANSLATE'))}>
              <span className='TRANSLATE'></span>
              <span className='margin-left-8'>{t('MNU_NEW_TRANSLATE')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_SEND_DATA')} onClick={() => handleClick(t('MNU_NEW_SEND_DATA'))}>
              <span className='OUTBOUND_TEMPLATE'></span>
              <span className='margin-left-8'>{t('MNU_NEW_SEND_DATA')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_VAR')} onClick={() => handleClick(t('MNU_NEW_VAR'))}>
              <span className='VARIABLE'></span>
              <span className='margin-left-8'>{t('MNU_NEW_VAR')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_LOOP')} onClick={() => handleClick(t('MNU_NEW_LOOP'))}>
              <span className='LOOP_ITEM'></span>
              <span className='margin-left-8'>{t('MNU_NEW_LOOP')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_ITEM_LIST')} onClick={() => handleClick(t('MNU_NEW_ITEM_LIST'))}>
              <span className='ITEM_LIST'></span>
              <span className='margin-left-8'>{t('MNU_NEW_ITEM_LIST')}</span>
            </MenuItem>
            {((selectedNode?.ICON_DISPLAY === "CONDITION_IF" && showElse) || (showElse)) &&
            (<MenuItem name={t('MNU_NEW_ELSE_BLOCK')} onClick={() => handleClick(t('MNU_NEW_ELSE_BLOCK'))}>
                  <span className='ELSE_NAME'></span>
                  <span className='margin-left-8'>{t('MNU_NEW_ELSE_BLOCK')}</span>
            </MenuItem>)}
            <MenuItem name={t('MNU_NEW_PLUG')} onClick={() => handleClick(t('MNU_NEW_PLUG'))}>
              <span className='CALL_PLUGIN'></span>
              <span className='margin-left-8'>{t('MNU_NEW_PLUG')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_CALL_WF')} onClick={() => handleClick(t('MNU_NEW_CALL_WF'))}>
              <span className='CALL_WORKFLOW'></span>
              <span className='margin-left-8'>{t('MNU_NEW_CALL_WF')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_TP_LOOKUP')} onClick={() => handleClick(t('MNU_NEW_TP_LOOKUP'))}>
              <span className='TRADING_PARTNER_LOOKUP'></span>
              <span className='margin-left-8'>{t('MNU_NEW_TP_LOOKUP')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_USE_ACTION')} onClick={() => handleClick(t('MNU_USE_ACTION'))}>
              <span className='ACTION_ITEM'></span>
              <span className='margin-left-8'>{t('MNU_USE_ACTION')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_COMMENT')} onClick={() => handleClick(t('MNU_NEW_COMMENT'))}>
              <span className='COMMENT'></span>
              <span className='margin-left-8'>{t('MNU_NEW_COMMENT')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_ERR_HANDLER')} onClick={() => handleClick(t('MNU_NEW_ERR_HANDLER'))}>
              <span className='ERROR_HANDLER'></span>
              <span className='margin-left-8'>{t('MNU_NEW_ERR_HANDLER')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_NEW_TRACKING_REPORT_ITEM')} onClick={() => handleClick(t('MNU_NEW_TRACKING_REPORT_ITEM'))}>
              <span className='TRACKING_REPORT_ITEM'></span>
              <span className='margin-left-8'>{t('MNU_NEW_TRACKING_REPORT_ITEM')}</span>
            </MenuItem>
            <MenuItem name={t('MNU_DEL_WF_ITEM')} onClick={() => handleClick(t('MNU_DEL_WF_ITEM'))}>
              <span className='SYMBOL_DELETE'></span>
              <span className='margin-left-8'>{t('MNU_DEL_WF_ITEM')}</span>
            </MenuItem>
            <MenuItem disabled={isDisable || selectedNode?.ICON_DISPLAY === 'CONDITION_ELSE'} name={t("MNU_COPY")} onClick={() => setIsCopied({ paste: false, copy: true, dispatchFrom: 'CsvMenu', treeType: parentScreen })}>
              <span className={"COPY"}></span>
              <span className={"margin-left-8"}>{t("MNU_COPY")}</span>
            </MenuItem>
            {isCopied?.copiedNodes?.length ? <MenuItem name={t("MNU_PASTE")} onClick={() => setIsCopied({ ...isCopied, paste: true, dispatchFrom: 'BlankMenu', treeType: parentScreen })}>
              <span className={"DOCUMENT"}></span>
              <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
            </MenuItem> : ''}
          </MenuList>
        </Paper>
      </ContextMenu>
      <NewComment openModal={menuOption === t('MNU_NEW_COMMENT')} toggle={() => handleClick(null)}></NewComment>
      <NewGetData openModal={menuOption === t('MNU_NEW_GET_DATA')} toggle={() => handleClick(null)} />
      <NewTranslateData openModal={menuOption === t('MNU_NEW_TRANSLATE')} toggle={() => handleClick(null)} />
      <NewVariable openModal={menuOption === t('MNU_NEW_VAR')} toggle={() => handleClick(null)} />
      <NewConditionalIfField openModal={menuOption === t('MNU_NEW_ITEM_LIST')} toggle={() => handleClick(null)} />
      <NewConditionalELSEField openModal={menuOption === t('MNU_NEW_ELSE_BLOCK')} toggle={() => handleClick(null)} />
      <CopyAndPaste isCopied={isCopied} setIsCopied={setIsCopied} contextMenuType={isCopied?.dispatchFrom === "keyPress" ? isCopied?.dispatchFrom : "BlankMenu"} treeType={parentScreen}/>
      <NewAction openModal={menuOption === t('MNU_USE_ACTION')} toggle={() => handleClick(null)} />
      <NewLoop openModal={menuOption === t('MNU_NEW_LOOP')} toggle={() => handleClick(null)} />
      <Delete openModal={menuOption === t('MNU_DEL_WF_ITEM')} toggle={() => handleClick(null)}/>
      <NewPlugin openModal={menuOption === t('MNU_NEW_PLUG')} toggle={() => handleClick(null)} />
      <NewCallWorkflow openModal={menuOption === t('MNU_NEW_CALL_WF')} toggle={() => handleClick(null)} />
      <NewTradingPartnerLookup openModal={menuOption === t('MNU_NEW_TP_LOOKUP')} toggle={() => handleClick(null)} />
      <NewErrorHandler openModal={menuOption === t('MNU_NEW_ERR_HANDLER')} toggle={() => handleClick(null)} />
      <NewSendData openModal={menuOption === t('MNU_NEW_SEND_DATA')} toggle={() => handleClick(null)} />
      <NewTrackingReport openModal={menuOption === t('MNU_NEW_TRACKING_REPORT_ITEM')} toggle={() => handleClick(null)} />
    </>
  )
}

export default WorkflowTemplateOptionsMenu